import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const CenteredSpinner = props => {
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    "data-test-id": props['data-test-id'],
    inlineSize: "100%",
    blockSize: "100%",
    alignSelf: "center",
    justifySelf: "center"
  }, props.absolute && {
    position: 'absolute',
    insetBlockStart: '0',
    insetInlineStart: '0'
  }, {
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      grow: true,
      label: props.label,
      showLabel: !!props.label
    })
  }));
};